import React from 'react'
import {motion} from "framer-motion";
import { Zap } from 'lucide-react';
import { Link } from 'react-router-dom';

const SubscriptionPrompt = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
    >
      <motion.div
        initial={{ scale: 0.5, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.5, opacity: 0 }}
        className="relative w-11/12 max-w-md p-8 bg-white rounded-2xl shadow-2xl border-t-4 border-[#FF6C6C]"
      >
        <div className="absolute -top-12 left-1/2 -translate-x-1/2">
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
            className="bg-white rounded-full p-3 shadow-lg"
          >
            <Zap className="w-12 h-12 text-[#FF6C6C]" />
          </motion.div>
        </div>

        <div className="text-center">
          <motion.h2 
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.3 }}
            className="mb-4 text-2xl font-bold text-gray-800"
          >
            Upgrade to Send SMS Campaigns
          </motion.h2>
          
          <motion.div
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.4 }}
            className="mb-8 space-y-4"
          >
            <p className="text-gray-600 leading-relaxed">
              Your free trial doesn't include SMS campaign blasting. Upgrade now to unlock:
            </p>
            <div className="space-y-2">
              <div className="flex items-center justify-center space-x-2 text-sm">
                <div className="flex items-center px-3 py-1.5 bg-gray-50 rounded-full">
                  <span className="w-2 h-2 bg-green-500 rounded-full mr-2"></span>
                  Bulk SMS Campaigns
                </div>
              </div>
              <div className="flex items-center justify-center space-x-2 text-sm">
                <div className="flex items-center px-3 py-1.5 bg-gray-50 rounded-full">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mr-2"></span>
                  Lower Cost Per SMS
                </div>
              </div>
            
            </div>
          </motion.div>

          <motion.div
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.5 }}
            className="space-y-4"
          >
            <Link
              to="/pricing"
              className="inline-block px-8 py-3.5 text-white font-medium transition-all duration-300 bg-[#FF6C6C] rounded-lg hover:bg-[#ff5353] hover:shadow-lg hover:shadow-[#FF6C6C]/30 transform hover:-translate-y-0.5"
            >
              Upgrade Subscription
            </Link>
            <div>
              <button
                onClick={() => window.history.back()}
                className="inline-flex items-center px-6 py-2.5 text-gray-600 font-medium transition-all duration-300 border border-gray-200 rounded-lg hover:bg-gray-50 hover:text-gray-800 hover:border-gray-300 transform hover:-translate-y-0.5"
              >
                <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                </svg>
                Go Back
              </button>
            </div>
            <p className="text-xs text-gray-500">
              Starting from only GHC 99/month
            </p>
          </motion.div>
        </div>

        <div className="absolute -bottom-10 left-1/2 -translate-x-1/2">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6 }}
            className="px-4 py-2 bg-white/80 backdrop-blur-sm rounded-full text-xs text-gray-500 w-[300px] text-center"
          >
            🚀 Unlock full SMS campaign capabilities
          </motion.div>
        </div>
      </motion.div>
    </motion.div>
  )
}

export default SubscriptionPrompt